<template>
  <a-skeleton active :loading="loading" :title="false" :paragraph="{rows: 8, width: 800}">
    <div v-if="has_device && !confirmed">
      <p
        class="mfa-p"
      >For quick setup plase scan following QR code using an authenticator app such as Google Authenticator or Authy.</p>
      <VueQrcode :value="config_url"></VueQrcode>
      <p
        class="mfa-p"
      >After you configured your authenticator app, enter a test code to confirm if secrets are sync correctly.</p>
      <a-form layout="inline" :form="form" v-if="!confirmed">
        <a-form-item>
          <a-input
            size="large"
            v-decorator="['token',
                    { rules: [{ required: true, message: 'Please input your test code!', type: 'string', pattern: new RegExp(/^[0-9]{6,8}$/)  }] },]"
            placeholder="Enter test code"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-button size="large" shape="round" type="primary" @click="handleSubmit">Confirm</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div v-else-if="has_device && confirmed">
      <p class="mfa-p"><a-icon type="check-circle" /> This device is already activated and ready to be used.</p>
    </div>
    <div v-else>
      <p class="mfa-p">No existing device found.</p>
      <a-button size="large" shape="round" type="primary" @click="createDevice">Create new device</a-button>
    </div>
  </a-skeleton>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
export default {
  data() {
    return {
      loading: true,
      form: this.$form.createForm(this)
    };
  },
  components: {
    VueQrcode
  },
  props: {
    otpType: {
      type: String,
      default: "totp"
    }
  },
  mounted: async function() {
    try {
      await this.$store.dispatch("axioms/getItem", {
        endpoint: "mfa/devices/" + this.otpType + "/users",
        uuid: this.$auth.session.id_payload.sub
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  methods: {
    handleSubmit: function() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("axioms/patchItem", {
              endpoint: "mfa/devices/" + this.otpType + "/users",
              uuid: this.$auth.session.id_payload.sub,
              data: values
            });
            await this.$notification.success({
              message: "Valid token!",
              description: "All setup now for authenticator app."
            });
          } catch (error) {
            console.error(error);
            await this.$notification.error({
              message: "Invalid token!",
              description:
                "Please scan barcode again to complete a fresh setup."
            });
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    },
    createDevice: async function() {
      let uuid = this.$auth.session.id_payload.sub;
      try {
        await this.$store.dispatch("axioms/createItem", {
          endpoint: "mfa/devices/" + this.otpType + "/users/"+uuid,
          data: {}
        });
        await this.$notification.success({
          message: "Device created!",
          description: "Please scan barcod to complete setup."
        });
        await this.$store.dispatch("axioms/getItem", {
          endpoint: "mfa/devices/" + this.otpType + "/users",
          uuid: uuid
        });
      } catch (error) {
        console.error(error);
        await this.$notification.error({
          message: "Device already exists.!",
          description: "Something went wrong."
        });
      }
    }
  },
  computed: {
    config_url() {
      return this.$store.state.axioms[
        "mfa/devices/" + this.otpType + "/users_item"
      ].config_url
        ? this.$store.state.axioms[
            "mfa/devices/" + this.otpType + "/users_item"
          ].config_url
        : "";
    },
    has_device() {
      return this.$store.state.axioms[
        "mfa/devices/" + this.otpType + "/users_item"
      ]
        ? this.$store.state.axioms[
            "mfa/devices/" + this.otpType + "/users_item"
          ]
        : false;
    },
    confirmed() {
      return this.$store.state.axioms[
        "mfa/devices/" + this.otpType + "/users_item"
      ].confirmed
        ? this.$store.state.axioms[
            "mfa/devices/" + this.otpType + "/users_item"
          ].confirmed
        : false;
    }
  }
};
</script>